const pagesLaborCoreInstanceEn = {
  laborCore: "Labor Core",
  tabs: {
    detail: "Detail",
    data: "Data",
    operationActivity: "Operation Activity",
  },
  instanceStatus: {
    completed: "Completed",
    inProgress: "In Progress",
    aborted: "Aborted",
  },
  requestedFor: "Requested for",
  assignee: "Assignee",
  progress: {
    title: "Task Progress",
  },
  notStarted:
    "This operation task is not started yet and cannot be edited. It starts when the dependent prior operation task is completed.",
  task: {
    editSuccess: "Task updated successfully",
    approveSuccess: "Task approved successfully",
  },
};

export default pagesLaborCoreInstanceEn;
